import { z } from "zod";

const schema = z.object({
  VITE_ENVIRONMENT: z.enum(["staging", "production"]).default("staging"),
  VITE_API_BASE_URL: z.url().default("http://localhost"),
  VITE_OAUTH_BASE_URL: z.url(),
  VITE_OAUTH_CLIENT_ID: z.string().min(1),
  VITE_OAUTH_AUDIENCE: z.string().min(1),
  VITE_OAUTH_SCOPE: z.string().default("openid profile email offline_access"),
});

const parsed = schema.parse(import.meta.env);

export const env = {
  environment: parsed.VITE_ENVIRONMENT,
  apiBaseUrl: parsed.VITE_API_BASE_URL,
  oauth: {
    baseUrl: parsed.VITE_OAUTH_BASE_URL,
    clientId: parsed.VITE_OAUTH_CLIENT_ID,
    audience: parsed.VITE_OAUTH_AUDIENCE,
    scope: parsed.VITE_OAUTH_SCOPE,
  },
} as const;
